module.exports = __webpack_public_path__ + "ddae819d9f61fc0331c3e513920f53bb.gif";